import React from 'react';

import { FormattedMessage } from 'react-intl';

import { FREE_TRIAL_DURATION_IN_MINUTES } from 'constants/freeTrial';
import { PATHS } from 'constants/pathsB2c';

import {
  StyledContainer,
  StyledMessagesContainer,
  SeeOffersLink,
} from './FreeTrialEndMessage.style';
import { MessageText } from '../../Message.style';

const FreeTrialEndMessage: React.FunctionComponent = () => {
  return (
    <StyledContainer>
      <StyledMessagesContainer>
        <MessageText>
          <FormattedMessage
            id={'expired-messages.free-trial-end.trial-is-finished'}
            values={{ duration: FREE_TRIAL_DURATION_IN_MINUTES }}
          />
        </MessageText>
        <MessageText>
          <FormattedMessage id={'expired-messages.free-trial-end.discover-our-offers'} />
        </MessageText>
      </StyledMessagesContainer>
      <SeeOffersLink to={PATHS.BAM_ONLINE_OFFERS} translationId={'expired-messages.see-offers'} />
    </StyledContainer>
  );
};

export default FreeTrialEndMessage;
